// https://stackoverflow.com/questions/47968529/how-do-i-use-jquery-and-jquery-ui-with-parcel-bundler
import jquery from 'jquery';
export default (window.$ = window.jQuery = jquery);